import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";

export const relevantInsightTypeLookup = {
    [InsightType.IHUB]: InsightType.GENERATED_G4S_RELEVANT,
};

export const shortenedInsightTypeLookup = {
    [InsightType.IHUB]: InsightType.GENERATED_G4S_SHORTENED,
};
